import { ChangeItem, ChangeType } from '../types/deployment';

export function transformMergedPRs(mergedPRs: any[]): ChangeItem[] {
  return mergedPRs.map(pr => {
    const text = pr.title;
    const link = pr.html_url;

    let tags: string[] = [];
    if (pr.labels && Array.isArray(pr.labels)) {
      tags = pr.labels.map((label: any) => label.name.toLowerCase());
    }

    let type: ChangeType | undefined = undefined;
    const titleLower = pr.title.toLowerCase();
    if (titleLower.includes('fix') || titleLower.includes('bug')) {
      type = 'bugfix';
    } else if (titleLower.includes('feature') || titleLower.includes('add')) {
      type = 'feature';
    } else if (titleLower.includes('enhancement')) {
      type = 'enhancement';
    } else if (titleLower.includes('security')) {
      type = 'security';
    }

    return {
      text,
      tags,
      link,
      type,
    };
  });
}
